import config from '../data/config.json';
import dict from '../data/dictionary.json';
import { plotPopupTemplate } from '../data/htmlTemplates.js';

import Mustache from 'mustache';
import L from './leaflet.circle-sector.js';

import { Sesion, Datos, Layers } from '../main.js';
import { Mimapa } from './map.js';
import { sumMeasureTaxon, sumPropInfoTaxon, getTaxonLabel } from './taxons.js';
import { getLiteral, getDate, uriToLiteral, firstUppercase, getColor, getColorMix, getPreferredLang, applyPrefix } from './util.js';

// colores parcelas
function pasaFiltroParcela(plot, tx) {
	if (!Sesion.taxonesFiltros[tx])
		return true;
	else {
		for (const par in Sesion.taxonesFiltros[tx]) {
			const val = sumMeasureTaxon(plot[par], tx);
			// compruebo si NO pasa el filtro
			if (val < Sesion.taxonesFiltros[tx][par].min || 
					(val > Sesion.taxonesFiltros[tx][par].max && config.maxValuesPlot[par] != Sesion.taxonesFiltros[tx][par].max))
				return false;
		}
		return true;
	}
}
function pasaFiltroPar(plot, par, tx) {
	if (!Sesion.taxonesFiltros[tx])
		return true;
	else {
		if (Sesion.taxonesFiltros[tx][par]) {
			const val = sumMeasureTaxon(plot[par], tx);
			// compruebo si NO pasa el filtro
			if (val < Sesion.taxonesFiltros[tx][par].min || 
					(val > Sesion.taxonesFiltros[tx][par].max && config.maxValuesPlot[par] != Sesion.taxonesFiltros[tx][par].max))
				return false;
		}
		return true;
	}
}

// rehago teniendo en cuenta los filtros de taxón: Sesion.taxonesFiltros
function colorParcela(plot) {
	if (Sesion.taxones.length == 0) {
		// miro si hay filtro de treeUri
		if (!pasaFiltroParcela(plot, config.treeUri))
			return { colext: config.coloutext, colint: config.coloutint }; // no pasa el filtro
		else 
			return { colext: config.colores[config.colplotind][8],
				colint: getColor(sumMeasureTaxon(plot.nt, config.treeUri), config.ntSatParcela, config.colores[config.colplotind]) };	
				//colint: getColor(numArbsTaxon(plot.ntrees, config.treeUri), config.arbsSatParcela, config.colores[config.colplotind]) };	
	}
	else {
		// preinicializo
		let colext = [];
		let colint = [];
		// extraigo los colores
		for (let ind = 0; ind < Sesion.taxones.length; ind++) {			
			const tx = Sesion.taxones[ind];
			const nttx = sumMeasureTaxon(plot.nt, tx);
			if (nttx > 0 && pasaFiltroParcela(plot, tx)) {
				// incluyo colores
				colext.push( config.colores[Sesion.taxonesColores[ind]][8] );
				colint.push( getColor(nttx, config.ntSatParcela, config.colores[Sesion.taxonesColores[ind]]) );			
			}
		}
		// actúo según el resultado
		if (colext.length == 0) 
			return { colext: config.coloutext, colint: config.coloutint }; // no pasa el filtro
		else if (colext.length == 1)
			return { colext: colext[0], colint: colint[0] }; // devuelvo un único color (sin arrays)
		else
			return { colext: getColorMix(colext), // en el exterior devuelvo mezcla
				colint: colint };
	}
}


// refino para no usar secciones en zooms bajos por eficiencia
function ajustarColorParcelas(puris) {
	//console.log("#parcelas ajustar color: " + puris.length);
	//console.time("ajustarColorParcelas");
	// en modo mono no hay secciones, agrego colores
	const modomono = Sesion.zoom < config.zParcelaMulti;
	let repintar = []; // guardo parcelas a repintar (si cambió el número de segmentos)
	for (let puri of puris) {
		if (Sesion.parPintadas[puri]) {
			const plot = Datos.parcelas[puri];
			const { colext, colint } = colorParcela(plot);
			//const colint = colorParcela(plot, false);
			//const colext = colorParcela(plot, true);
			// ajusto multi
			if (Array.isArray(colint))		
				Sesion.parPintadasMulti[puri] = [colext, getColorMix(colint)];
			else
				delete Sesion.parPintadasMulti[puri];
			// número de colores
			const newnc = modomono? 1 : Array.isArray(colint)? colint.length : 1;
			const oldnc = Array.isArray(Sesion.parPintadas[puri])? Sesion.parPintadas[puri].length : 1;
			if (newnc != oldnc) { // toca repintar la parcela...
				// quito lo anterior
				if (oldnc == 1)
					Layers.parcs.removeLayer(Sesion.parPintadas[puri]);
				else {
					for (let ppint of Sesion.parPintadas[puri])
						Layers.parcs.removeLayer(ppint);
				}
				// borro y marco para repintar
				delete Sesion.parPintadas[puri];
				repintar.push(puri);
			}
			else { // sólo cambio el color
				if (newnc == 1) {
					const newcolint = Sesion.parPintadasMulti[puri]? Sesion.parPintadasMulti[puri][1] : colint;
					Sesion.parPintadas[puri].setStyle( {fillColor: newcolint, color: colext} );
				}
				else {
					for (let ind=0; ind<Sesion.parPintadas[puri].length; ind++)
						Sesion.parPintadas[puri][ind].setStyle( {fillColor: colint[ind], color: colext} );
				}
			}	
		}
	}
	// llamo a repintar
	if (repintar.length > 0) 
		pintarParcelas(repintar);
	//console.timeEnd("ajustarColorParcelas");
}


function pintarParcelas(puris) {
	// cuento num de parcelas pintadas
	let numparcelas = 0;
	// en modo mono no hay secciones, agrego colores
	const modomono = Sesion.zoom < config.zParcelaMulti;
	// pinto las parcelas pendientes
	for (let puri of puris) {
		// sólo pintamos si no estaba la parcela en la capa
		if (!Sesion.parPintadas[puri]) {
			const plot = Datos.parcelas[puri];
			const pcentro = L.latLng(plot.lat, plot.lng);
			const { colext, colint } = colorParcela(plot);
			//const colint = colorParcela(plot, false);
			//const colext = colorParcela(plot, true);
			// si hay varios colores...
			if (Array.isArray(colint)) {
				// es multi, guardo colores agregados
				Sesion.parPintadasMulti[plot.iri] = [colext, getColorMix(colint)];
				if (modomono) { // en modo mono...
					// creo círculo y lo guardo, lo añado al layer group y pongo popup
					Sesion.parPintadas[plot.iri] = L.circle(pcentro, {color: Sesion.parPintadasMulti[plot.iri][0], 
							weight: 2, fillColor: Sesion.parPintadasMulti[plot.iri][1],
							fillOpacity: 0.75, radius: Sesion.radioParPintadas})
						.bindPopup(popupParcela(plot), {maxWidth: 800})
						//.on('dblclick ', function(e) { Mimapa.setView([plot.lat, plot.lng], config.zArbol + 2); }) // añado aquí también handler de dblclick 	
						.addTo(Layers.parcs);				
				}
				else { // modo multi			
					// creo un sector circular por color
					const grados = 360/colint.length;
					Sesion.parPintadas[plot.iri] = [];
					for (let ind=0; ind<colint.length; ind++) {
						Sesion.parPintadas[plot.iri].push(
							L.circle(pcentro, {color: colext, weight: 2, fillColor: colint[ind],
									fillOpacity: 0.75, radius: Sesion.radioParPintadas, startAngle: grados*ind, endAngle: grados*(ind+1)})
								.bindPopup(popupParcela(plot), {maxWidth: 800})
								//.on('dblclick ', function(e) { Mimapa.setView([plot.lat, plot.lng], config.zArbol + 2); }) // añado aquí también handler de dblclick 	
								.addTo(Layers.parcs)
						);
					}
				}
			}
			else { // sólo un color
				// creo círculo y lo guardo, lo añado al layer group y pongo popup
				Sesion.parPintadas[plot.iri] = L.circle(pcentro, {color: colext, weight: 2, fillColor: colint,
						fillOpacity: 0.75, radius: Sesion.radioParPintadas})
					.bindPopup(popupParcela(plot), {maxWidth: 800})
					//.on('dblclick ', function(e) { Mimapa.setView([plot.lat, plot.lng], config.zArbol + 2); }) // añado aquí también handler de dblclick 	
					.addTo(Layers.parcs);
				// no es multi
				delete Sesion.parPintadasMulti[plot.iri];
			}
			// desmarco regenerar popup
			delete Sesion.parPopupsRegenerar[plot.iri];
			// contabilizo
			numparcelas++;
		}
	}
	return numparcelas;
}


// cambio estrategia de reajuste de popups: como regenerarlos todos puede ser lento,
// simplemente marco las parcelas con un regenerado de popup pendiente
// como capturo el evento de popupopen en map.js, hago ahí el regenerado
function ajustarPopupsParcelas(puris) {
	for (let puri of puris) {
		if (Sesion.parPintadas[puri]) {
			Sesion.parPopupsRegenerar[puri] = true; // sólo marco las parcelas que requieren regenerar el popup		
			/* TODO previo
			if (Array.isArray(Sesion.parPintadas[puri])) {
				for (let sc of Sesion.parPintadas[puri])
					sc.bindPopup(popupParcela(Datos.parcelas[puri], {maxWidth: 800}));
			}
			else 
				Sesion.parPintadas[puri].bindPopup(popupParcela(Datos.parcelas[puri], {maxWidth: 800}));*/
		}
	}
}


// popups parcelas
function popupParcela(plot) {
	// preparo plantilla para el mustache
	let parctemp = {};
	parctemp.piri = plot.iri;
	// nombre parcela
	//parctemp.plot = getLiteral(dict.plot) + " " + applyPrefix(plot.iri, config.prefixes);	
	parctemp.plot = getLiteral(dict.plot) + " " + uriToLiteral(plot.iri, "plot-");
	// fuente
	parctemp.source = getLiteral(dict["source"+plot.ifn]);
	// dataCapture
	if (plot.dataCapture) {
		const dclab = getDate(plot.dataCapture);
		if (dclab)	
			parctemp.dataCapture = getLiteral(dict.dataCapture) + " " + dclab;
	}
	// otherInvs (TODO: rehacer con el IFN4)
	const potro = config.ifnVersions[0] === plot.ifn? config.ifnVersions[1] : config.ifnVersions[0];
	if (plot["plot" + potro]) {
		parctemp.otherInvs = getLiteral(dict.otherinvs) + ": " + getLiteral(dict[potro.toUpperCase()]);
		// IMPORTANTE: si habilito esto, hago la comparación automática (desactivado a petición de los forestales)
		//parctemp[potro] = true; // añadido para poner la comparación del inventario en el dashboard
	}
	// provincia
	if (plot.prov && Datos.provs[plot.prov]) {
		if (Datos.provs[plot.prov].label)
			parctemp.prov = getLiteral(dict.provinceof) + ' ' + getLiteral(Datos.provs[plot.prov].label);
	}
	// encabezado (especies)
	parctemp.head = [];
	parctemp.head.push('<th scope="col"></th>'); // primera celda del encabezado vacío
	// taxones seleccionados (si los hay)
	for (let tx of Sesion.taxones)
		parctemp.head.push( '<th scope="col" colspan="2" class="text-end">' + getTaxonLabel(tx, Sesion.nomci, true) + '</th>' );
	// si no hay taxones seleccionados no pongo tabla
	if (Sesion.taxones.length == 0)
		parctemp.notabla = true;
	// todos los taxones
	parctemp.head.push( '<th scope="col" class="text-end">' + getLiteral(dict.all) + '</th>' );
	// datos
	parctemp.rows = [];	

	// datos de existencias
	// me baso en los árboles/Ha para ver si hay datos de árboles
	const nt = sumMeasureTaxon(plot.nt, config.treeUri);
	if (nt == 0) 
		parctemp.notreedata = true;
	else {
		// preparo objetos para iterar
		const objs = [];
		objs.push( { prop : "nt", head : getLiteral(dict.numbertreesHA) } );
		objs.push( { prop : "ba", head : getLiteral(dict.basalareaM2HA) } );
		objs.push( { prop : "vwb", head : getLiteral(dict.volumewithbarkM3HA) } );
		objs.push( { prop : "vwob", head : getLiteral(dict.volumewithoutbarkM3HA) } );
		// itero
		for (let obj of objs) {
			let row = {};
			row.head = obj.head;
			row.els = [];
			// suma total
			let sumtotal = Number(sumMeasureTaxon(plot[obj.prop], config.treeUri).toFixed(1));
			// taxones seleccionados (si los hay)
			for (let tx of Sesion.taxones) {
				// obtengo suma de la especies
				let sumesp = Number(sumMeasureTaxon(plot[obj.prop], tx).toFixed(1));
				if (sumesp != 0) {
					let val = sumesp.toLocaleString(getPreferredLang());
					let valperc = '';
					// pongo porcentaje
					if (sumtotal > 0) {
						const perc = 100 * sumesp / sumtotal;
						valperc = ' (' + Number(perc.toFixed(1)).toLocaleString(getPreferredLang()) + '%)';				
					}
					// color rojo...
					if (!pasaFiltroPar(plot, obj.prop, tx))
						val = '<span class="text-danger fw-medium">' + val + '</span>';
					row.els.push(val);
					row.els.push(valperc);
				}
				else {
					row.els.push( '' );
					row.els.push( '' );
				}
			}
			// todos los taxones
			const nored = Sesion.taxones.length > 0 || pasaFiltroPar(plot, obj.prop, config.treeUri);
			const cad = nored? sumtotal.toLocaleString(getPreferredLang()) : 
				'<span class="text-danger fw-medium">' + sumtotal.toLocaleString(getPreferredLang()) + '</span>';			
			row.els.push( cad );
			// incluyo fila
			parctemp.rows.push(row);
		}
	}
	
	// obtengo el popup y lo devuelvo
	return Mustache.render(plotPopupTemplate, parctemp);
}


function quitarParcelas() {
	console.info("Borrando capa de parcelas...");
	// borro la capa de parcelas
	Layers.parcs.clearLayers();
	// inicializo la lista de parcelas pintadas
	Sesion.parPintadas = {};
	// inicializo la lista de parcelas pintadas con múltiples secciones
	Sesion.parPintadasMulti = {};
	// inicializo la lista de parcelas con popups para regenerar
	Sesion.parPopupsRegenerar = {};
}

export { pintarParcelas, ajustarColorParcelas, ajustarPopupsParcelas, popupParcela, quitarParcelas };